module.exports = __webpack_public_path__ + "img/NewsCenterDetails7_pic6.ae216eb9.png";